import index from "@/api/index.js"
export default {
	index,
}